<template>

    <section class="col cat-row" :class="{ frt : activeCard }">
        <!-- <h5 class="txt-grt-pnk">{{ rowTitle }}</h5> -->
        <h5 :style="{ color : Global.mockupConfig.colors.icons }">{{ rowTitle }}</h5>
        <div class="row-outer" ref="outer">
            <transition
            name="fadescale"
            @css="false">
                <div class="nv bw" v-show="numToSlide > 0" @click.prevent="prv">
                    <span class="ico">
                        <svg width="17" height="40" viewBox="0 0 17 40" fill="none">
                            <path d="M15 38L2.42285 20.5855C2.17042 20.236 2.17043 19.764 2.42285 19.4145L15 2" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </div>
            </transition>
            <div class="row-inner" ref="inner" :style="innerStyle" :class="{ dsbld : tempDsbld }">
                <slot></slot>
            </div>
            <transition
            name="fadescale"
            @css="false">
                <div class="nv fw" v-show="numToSlide < totalHidden" @click.prevent="nxt">
                    <span class="ico">
                        <svg width="17" height="40" viewBox="0 0 17 40" fill="none">
                            <path d="M2 2L14.5771 19.4145C14.8296 19.764 14.8296 20.236 14.5771 20.5855L2 38" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </div>
            </transition>
        </div>
    </section>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'CatRow',

        props: {
            rowTitle: String
        },

        data() {
            return {
                Global,
                isMounted: false,
                totalChildren: null,
                numToSlide: 0,
                activeCard: false,
                tempDsbld: false
            }
        },
        
        computed: {
            innerStyle() {
                if(!this.isMounted)
                    return
                else
                    return { width: 2 * Math.round((this.$refs.outer.clientWidth / 100 * 101) / 2) + 'px', transform: 'translateX(' + -this.numToSlide * this.wFactor + '%)' }
            },
            wFactor() {
                if (this.Global.windowWidth > 1599 && this.Global.windowWidth < 2000 && !this.Global.mockupConfig.verticalNav)
                    return 20
                else if (this.Global.windowWidth >= 2000 && !this.Global.mockupConfig.verticalNav)
                    return 16.65
                else if (this.Global.windowWidth < 1600 && this.Global.mockupConfig.verticalNav)
                    return 16.65
                else if (this.Global.windowWidth > 1599 && this.Global.windowWidth < 2000 && this.Global.mockupConfig.verticalNav)
                    return 14.28
                else if (this.Global.windowWidth >= 2000 && this.Global.mockupConfig.verticalNav)
                    return 12.5
                else
                    return 25
            },
            qFactor() {
                if (this.Global.windowWidth > 1599 && this.Global.windowWidth < 2000 && !this.Global.mockupConfig.verticalNav)
                    return 5
                else if (this.Global.windowWidth >= 2000 && !this.Global.mockupConfig.verticalNav)
                    return 6
                else if (this.Global.windowWidth < 1600 && this.Global.mockupConfig.verticalNav)
                    return 6
                else if (this.Global.windowWidth > 1599 && this.Global.windowWidth < 2000 && this.Global.mockupConfig.verticalNav)
                    return 7
                else if (this.Global.windowWidth >= 2000 && this.Global.mockupConfig.verticalNav)
                    return 8
                else
                    return 4
            },
            totalHidden() {
                return this.totalChildren - this.qFactor
            }
        },

        mounted() {
            this.init()
        },

        methods: {

            init() {
                this.isMounted = true
                this.totalChildren = this.$refs.inner.children.length
            },

            noEventsTemp() {
                this.tempDsbld = true
                setTimeout(() => { this.tempDsbld = false }, 550)
            },

            prv() {
                this.noEventsTemp()
                let oldPos = this.numToSlide
                if(this.numToSlide >= this.qFactor){
                    this.numToSlide = this.numToSlide - this.qFactor

                }else{
                    this.numToSlide = this.numToSlide - oldPos
                }
            },

            nxt() {
                this.noEventsTemp()
                let oldPos = this.numToSlide
                if(this.numToSlide + this.qFactor < this.totalHidden){
                    this.numToSlide = this.numToSlide + this.qFactor

                }else{
                    this.numToSlide = this.numToSlide + (this.totalHidden - oldPos)
                }
            },

            hoveredCard(param) {
                this.activeCard = param
            },


        }
    }
</script>